export function isDomain(domain) {
  return window.location.hostname === domain;
}

export function getEnvironment() {
  const match = window.location.pathname.match(/.*?\/(u|p)\/ns\/(html|html-test)\/\d+\/.*/);
  let env;

  if (window.location.hostname.indexOf("localhost") > -1) {
    env = "local";
  } else if (!match || (match[1] === "u" && match[2] === "html-test")) {
    env = "int";
  } else if (match[1] === "u" && match[2] === "html") {
    env = "uat";
  } /* if (match[1] === "p") */ else {
    env = "prod";
  }
  // console.debug("Environment:", env);
  return env;
}

export function isIntranetUser() {
  if (getEnvironment() === "local") return true;

  return (
    document.cookie.indexOf("SSOAUTHcoreprd") > -1 ||
    document.cookie.indexOf("SSOAUTHcoreint") > -1 ||
    document.cookie.indexOf("SSOAUTHcoreuat") > -1
  );
}

export function getGRP_JAPI_Url() {
  const env = getEnvironment();
  const protocol = isIntranetUser() ? "http://" : "https://";
  const hostname = {
    local: "uat-go.nomuranow.com",
    int: "uat-go.nomuranow.com",
    uat: "uat-go.nomuranow.com",
    prod: "go.nomuranow.com",
  };

  return protocol + hostname[env];
}
export function getUrlParam(key) {
  if (window.location.search.indexOf(`${key}=`) === -1) return null;
  let value = window.location.search.split(`${key}=`)[1];
  if (value) value = value.split("&")[0];
  return value;
}

export function getUcId() {
  const ucid = getUrlParam("ucid");
  if (!ucid) {
    console.warn("Warning - missing url param:" + "ucid");
    return "";
  }
  return ucid;
}
export function getPid() {
  const parts = window.location.pathname.split("/");
  const pid = parts[parts.length - 2];
  return pid;
}

export function getExtranetJAPIUrl() {
  const urls = {
    local: "https://uat-www.nomuranow.com/research/int-japi",
    int: "https://uat-www.nomuranow.com/research/int-japi",
    uat: "https://uat-www.nomuranow.com/research/japi",
    prod: "https://www.nomuranow.com/research/japi",
  };
  return urls[getEnvironment()];
}
